// Constants
import { onlyNumber } from '../../constants/normalize'

export const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export const changeCases = (array, index, field, value) => {
  return [
    ...array.slice(0, index),
    [
      {
        ...array[index][0],
        [field]: value
      },
      ...array[index].slice(1)
    ],
    ...array.slice(index + 1)
  ]
}

export const convertArrayToObject = (headers, cases, headerKey='label') => {
  let object = []
  let keys = []

  headers.map(header => {
    keys = [...keys, header[headerKey]]
  })

  keys = [...keys, 'Erro']

  cases.map(fields => {
    let values = []
    let error = ''

    fields.map(field => {
      values = [...values, field.value]
      if(field.error) error += field.error + ', '
    })

    object = [...object, [...values, error]]
  })

  object = object.map(item => {
    const newObject = {}
    item.map((val, i) => newObject[keys[i]] = val)

    return newObject
  })

  return object
}
